



export class AuthRequestVM {
    
    username?: string;
    
    sourceIP?: string;
    
}
